import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import NotificationService from "../../services/NotificationService";
import {
  listFail,
  listSuccess,
  updateStatusFail,
  updateStatusSuccess,
} from "../slices/notificationSlice";

function* list(data) {
  try {
    const ajax = yield call(NotificationService.list, data.payload);
    if (ajax.status === 200) {
      yield put(listSuccess(ajax.data));
    } else {
      yield put(
        listFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      listFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateStatus(data) {
  try {
    const ajax = yield call(
      NotificationService.updateNotificationStatus,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(updateStatusSuccess(ajax.data));
    } else {
      yield put(
        updateStatusFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateStatusFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

export default function* notificationSaga() {
  yield all([
    takeLatest("notifications/listRequest", list),
    takeLatest("notifications/updateStatusRequest", updateStatus),
  ]);
}
